module.exports = __webpack_public_path__ + "media/unipod/installation_vertical_2-091d053f.jpg";